// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paylixecommerce-modal.changelog-modal {
  width: 50vw;
  display: flex;
  flex-direction: column;
}

.changelog-modal-body {
  padding: 0;
  overflow: auto;
  height: calc(100% - 70px);
  flex: 1;
}
.changelog-modal-list {
  font-size: 14px;
}
.changelog-modal-list-body {
  padding: 1.25rem 1.5rem;
}
.changelog-modal-list-subheader {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  font-weight: 600;
  color: var(--black9);
  padding: 0.5rem 1.5rem;
  border-bottom: 1px solid var(--black1);
  cursor: pointer;
  background: var(--black0);
}
.changelog-modal-list-subheader:last-of-type {
  border-bottom: none;
}
.changelog-modal-list-subheader svg {
  cursor: pointer;
}
.changelog-modal-list-item svg {
  font-size: 16px;
}
.changelog-modal-list-item svg path {
  color: var(--green6);
}
.changelog-modal-list-item p {
  font-size: 0.85rem;
  font-weight: 400;
  color: var(--black9);
}
.changelog-modal-list-item h1 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--black9);
  padding-top: 0;
}
.changelog-modal-list-item h2 {
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--black9);
  padding-top: 1rem;
}
.changelog-modal-list-item h3 {
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--black9);
  padding-top: 1rem;
}
.changelog-modal-list-item ul li {
  color: var(--black9);
}
.changelog-modal-list-item h1 + p img {
  width: auto;
  object-fit: fill;
  border-radius: 0.25rem;
  border: 1px solid var(--black1);
}
.changelog-modal-list-item img {
  width: 100%;
  object-fit: fill;
  border-radius: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/customization/store/changelog-modal.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAIE;EACE,UAAA;EACA,cAAA;EACA,yBAAA;EACA,OAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAII;EACE,uBAAA;AAFN;AAKI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,sCAAA;EACA,eAAA;EACA,yBAAA;AAHN;AAKM;EACE,mBAAA;AAHR;AAMM;EACE,eAAA;AAJR;AAUM;EACE,eAAA;AARR;AASQ;EACE,oBAAA;AAPV;AAWM;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;AATR;AAYM;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAVR;AAYM;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AAVR;AAYM;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AAVR;AAaM;EACE,oBAAA;AAXR;AAeQ;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,+BAAA;AAbV;AAiBM;EACE,WAAA;EACA,gBAAA;EACA,qBAAA;AAfR","sourcesContent":[".paylixecommerce-modal.changelog-modal {\n  width: 50vw;\n  display: flex;\n  flex-direction: column;\n}\n\n.changelog-modal {\n\n  &-body {\n    padding: 0;\n    overflow: auto;\n    height: calc(100% - 70px);\n    flex: 1;\n  }\n\n  &-list {\n    font-size: 14px;\n\n    &-body {\n      padding: 1.25rem 1.5rem;\n    }\n\n    &-subheader {\n      display: flex;\n      justify-content: space-between;\n      font-size: 1rem;\n      font-weight: 600;\n      color: var(--black9);\n      padding: .5rem 1.5rem;\n      border-bottom: 1px solid var(--black1);\n      cursor: pointer;\n      background: var(--black0);\n\n      &:last-of-type {\n        border-bottom: none;\n      }\n\n      svg {\n        cursor: pointer;\n      }\n    }\n\n    &-item {\n\n      svg {\n        font-size: 16px;\n        path {\n          color: var(--green6);\n        }\n      }\n\n      p {\n        font-size: .85rem;\n        font-weight: 400;\n        color: var(--black9);\n      }\n\n      h1 {\n        font-size: 1.5rem;\n        font-weight: 600;\n        color: var(--black9);\n        padding-top: 0;\n      }\n      h2 {\n        font-size: 1.25rem;\n        font-weight: 500;\n        color: var(--black9);\n        padding-top: 1rem;\n      }\n      h3 {\n        font-size: 1.1rem;\n        font-weight: 500;\n        color: var(--black9);\n        padding-top: 1rem;\n      }\n\n      ul li {\n        color: var(--black9);\n      }\n\n      h1 + p {\n        img {\n          width: auto;\n          object-fit: fill;\n          border-radius: 0.25rem;\n          border: 1px solid var(--black1);\n        }\n      }\n\n      img {\n        width: 100%;\n        object-fit: fill;\n        border-radius: 0.5rem;\n      }\n    }\n\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
